import styled from 'styled-components';
import { IntegrationStatus } from '../../constants/integrationStatus';

export const StyledBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: capitalize;

  ${props => {
    switch(props.status) {
      case IntegrationStatus.CONNECTED:
        return `
          background: rgba(40, 167, 69, 0.15);
          color: #28a745;
          border: 1px solid rgba(40, 167, 69, 0.3);
        `;
      case IntegrationStatus.ERROR:
        return `
          background: rgba(217, 26, 44, 0.1);
          color: #d91a2c;
          border: 1px solid rgba(217, 26, 44, 0.2);
        `;
      case IntegrationStatus.UPCOMING:
        return `
          background: rgba(108, 117, 125, 0.1);
          color: #6c757d;
          border: 1px solid rgba(108, 117, 125, 0.2);
        `;
      default: // disconnected
        return `
          background: #eeeeee;
          color: #a3a5a9;
          border: 1px solid transparent;
        `;
    }
  }}
`;
